export default __webpack_public_path__ + "static/media/welcome_m@2x.6e46c07d.png";